import React from 'react';
import styled from "styled-components";
import {device} from "../components/Devices";
import {useState} from "react";
import {db} from "../firebaseConfig";
import {addDoc, collection} from "firebase/firestore";

function Contact() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const userCollectionRef = collection(db, "contactdata");

    const handleSubmit = (e) => {

        e.preventDefault();
        e.target.reset();

        addDoc(userCollectionRef, {
            name: name,
            email: email,
            subject: subject,
            message: message,
        })

            .then(() => {

                alert("Your message is successfully submitted!");
            })
            .catch((error) => {
                console.error(error.message);
            })

    }

    return (

        <Main_Contact_Container>
            <main>
                <h1>Contac<span>t Me</span></h1>
                <p>I am located in Amersfoort, the Netherlands. You can reach me by sending a message in this area or
                    find me via Linkedin:
                </p>
                <br/>
                <br/>
                <a href="https://www.linkedin.com/in/dennisrijkers/">Linke<span>din</span></a>
            </main>


            <section>
                <form
                    className="form_container"
                    onSubmit={handleSubmit}
                >

                    <div>
                        <input
                            type="text"
                            placeholder="Name"
                            onChange={(event) => setName(event.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Email"
                            onChange={(event) => setEmail(event.target.value)}
                        />

                    </div>

                    <input
                        type="text"
                        placeholder="Subject"
                        onChange={(event) => setSubject(event.target.value)}
                    />
                    <textarea
                        name="message"
                        id="message"
                        cols="30"
                        rows="10"
                        placeholder="Leave a message..."
                        onChange={(event) => setMessage(event.target.value)}
                    >
                    </textarea>

                    <button
                        type="submit"
                    >
                        Send Message
                    </button>

                </form>
            </section>


        </Main_Contact_Container>

    );
}

export default Contact;

const Main_Contact_Container = styled.div`

  width: auto;
  height: auto;
  min-height: 954px;
  max-height: 954px;
  background-color: transparent;
  margin-top: 120px;
  //position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  //border: 1px solid black;


  width: 320px;
  max-width: 320px;
  overflow-x: hidden;
  overflow-y: scroll;

  @media ${device.mobileM} {
    width: 375px;
    max-width: 375px;
  }

  @media ${device.mobileL} {
    width: 425px;
    max-width: 425px;
  }

  @media ${device.tablet} {
    width: 768px;
    max-width: 768px;
  }

  @media ${device.laptop} {
    width: 1024px;
    max-width: 1024px;
  }

  @media ${device.laptopL} {
    width: 1400px;
    max-width: 1440px;

  }


  main {

    
    width: 310px;
    min-width: 310px;
    max-width: 310px;
    height: 250px;
    max-height: 300px;
    //border: 1px solid black;

    display: flex;
    flex-direction: column;
    align-items: center;

    @media ${device.mobileM} {
      width: 335px;
      max-width: 375px;
    }
    @media ${device.mobileL} {
      width: 390px;
      max-width: 425px;
    }

    @media ${device.tablet} {
      width: 450px;
      margin-bottom: 40px;
      max-width: 730px;

    }


    @media ${device.laptopL} {
      max-width: 1440px;
      height: 400px;
      width: 1400px;
    }


    h1 {
      font-size: 35px;
      font-weight: lighter;
      color: var(--mainTextColor);
      margin-bottom: 50px;
      //margin-left: 60px;

      span {
        border-bottom: 2px solid var(--orange);
      }

      @media ${device.mobileM} {
        //margin-left: 90px;
      }
      @media ${device.mobileL} {
        //margin-left: 120px;
      }

      @media ${device.tablet} {
        //margin-left: 280px;
        margin-top: 50px;
      }


      @media ${device.laptopL} {
        //margin-left: 580px;
        margin-top: 100px;
        font-size: 50px;

      }

    }


    p {
      color: var(--blackShadow);
      padding-bottom: 10px;
      text-align: left;
      //border: 1px solid black;
      width: 100%;

      @media ${device.mobileM} {
        
        font-size: 20px;
        font-weight: lighter;
      }

      @media ${device.mobileL} {
        font-size: 25px;
        font-weight: lighter;
      }

      @media ${device.tablet} {
        font-size: 25px;
        font-weight: lighter;
      }

      @media ${device.laptopL} {
        font-size: 30px;
        font-weight: lighter;
        width: 800px;

      }

    }


    a {
      text-align: left;
      //border: 1px solid black;
      width: 100%;
      font-size: 30px;
      font-weight: lighter;
      color: var(--mainTextColor);
      text-decoration: none;
      margin-left: 0;

      span {
        color: var(--orange);
        
      }

      @media ${device.mobileM} {
        
        //font-size: 20px;
        //font-weight: lighter;
      }

      @media ${device.mobileL} {
        
        font-size: 25px;
        font-weight: lighter;
      }

      @media ${device.tablet} {
        font-size: 25px;
        font-weight: lighter;
      }

      @media ${device.laptopL} {
        font-size: 30px;
        font-weight: lighter;
        width: 800px;

      }
    }


  }


  section {
    width: 100%;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //border: 1px solid black;

    @media ${device.laptopL} {
      margin-top: 100px;
    }

    .form_container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-width: 310px;

      @media ${device.mobileM} {
        max-width: 340px;
      }

      @media ${device.mobileL} {
        max-width: 390px;
      }

      @media ${device.tablet} {
        max-width: 700px;
      }

      @media ${device.laptopL} {
        max-width: 100%;
      }


      div {
        padding: 5px;
        display: flex;
        flex-direction: row;
        //justify-content: space-between;

        input {

          width: 150px;
          height: 30px;
          padding: 5px;
          margin: 4px;
          border-radius: 5px;
          border: 1px solid var(--blackShadow);
          background-color: var(--mainBackGroundColor);
          color: var(--mainTextColor);
          font-size: 16px;

          @media ${device.mobileM} {
            width: 165px;
            //margin: 10px;
          }

          @media ${device.mobileL} {
            width: 190px;
            //margin: 10px;
          }

          @media ${device.tablet} {
            width: 345px;
          }

          @media ${device.laptopL} {
            width: 396px;
            height: 40px;
          }

          &::placeholder {
            color: var(--dimGrey);
            font-size: 18px;
          }

        }
      }

      input {
        width: 100%;
        height: 30px;
        padding: 5px;
        margin-bottom: 4px;
        border-radius: 5px;
        border: 1px solid var(--blackShadow);
        background-color: var(--mainBackGroundColor);
        color: var(--mainTextColor);
        font-size: 16px;

        @media ${device.laptopL} {
          height: 40px;
        }

        &::placeholder {
          color: var(--dimGrey);
          font-size: 18px;
        }

      }

      textarea {
        width: 100%;
        height: 200px;
        padding: 5px;
        margin-top: 5px;
        border-radius: 5px;
        border: 1px solid var(--blackShadow);
        background-color: var(--mainBackGroundColor);
        color: var(--mainTextColor);
        font-size: 16px;

        &::placeholder {
          color: var(--dimGrey);
          font-size: 18px;
        }

      }

      button {

        width: auto;
        height: 35px;
        padding: 5px;
        margin: 30px 175px 5px 0;
        border-radius: 5px;
        border: 1px solid var(--orange);
        background-color: var(--mainBackGroundColor);
        color: var(--mainTextColor);
        font-size: 17px;
        cursor: pointer;

        @media ${device.mobileM} {
          margin: 30px 175px 0 -40px;
        }

        @media ${device.mobileL} {
          margin: 30px 175px 0 -90px;
        }

        @media ${device.tablet} {
          margin: 30px 175px 0 -300px;
          width: 225px;
        }

        @media ${device.laptopL} {
          margin: 30px 175px 0 -400px;
          width: 225px;
          height: 40px;
        }

        &:hover {
          background-color: var(--orange);
          color: var(--mainBackGroundColor);
        }

      }

    }
  }

`;



